/** Parses a form input's value as a number, falling back instead of propagating NaN —
 * `Number("")`/`Number("-")` etc. would otherwise flow into state and eventually
 * `JSON.stringify` to `null` on save, silently dropping the field. */
export function numOr(raw: string, fallback: number): number {
  const n = Number(raw);
  return Number.isFinite(n) ? n : fallback;
}

/**
 * Class for colouring a gross score by how it did against par, so a card can be read
 * at a glance instead of by arithmetic. Purely presentational — nothing in `shared/`
 * scores a round this way, and formats like Stableford or Skins award their points on
 * their own terms.
 */
export function scoreTone(strokes: number | null, par: number): string {
  if (strokes === null) return "";
  const delta = strokes - par;
  if (delta <= -2) return "tone-eagle";
  if (delta === -1) return "tone-birdie";
  if (delta === 0) return "";
  if (delta === 1) return "tone-bogey";
  return "tone-double";
}
